import { motion } from "framer-motion";
import { useCallback, useState } from "react";
import Button from "../../../../components/Button/Button.tsx";
import InputField from "../../../../core/data-entry/InputField.tsx";
import Modal from "../../../../core/feedback/Modal.tsx";
import "../DivergenciasSAT.css";

export type ModalVerificarCteProps = {
    isOpen: boolean;
    onClose: () => void;
    buscarCTE: (cte: number) => void;
    isLoading: boolean;
};

function ModalVerificarCte({
    isOpen,
    onClose,
    buscarCTE,
    isLoading,
}: ModalVerificarCteProps) {

    const [cte, setCte] = useState<number | null>(null);

    const handleClose = useCallback(() => {
        onClose();
    }, [onClose]);

    const handleVerificar = useCallback(() => {
        if (cte) {
            buscarCTE(cte);
        }
    }, [cte, buscarCTE]);

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <motion.div
                onClick={(e) => e.stopPropagation()}
                initial={{ opacity: 0, y: 50 }}
                exit={{ opacity: 0, y: 50 }}
                animate={{
                    opacity: 1,
                    y: 0,
                }}
                transition={{ duration: 0.3 }}>
                <div className="modal-verificar-cte modal-content">
                    <InputField
                        type="number"
                        label="Verificar CTE"
                        value={cte ? cte.toString() : ""}
                        onChange={(e) => setCte(Number(e.target.value))}
                        placeholder="Digite o número do CTE"
                    />
                    <Button
                        label="Buscar"
                        loading={isLoading}
                        onClick={handleVerificar}
                        icon="Check"
                        fullWidth
                        disabled={!cte || cte <= 0}
                    />
                </div>
            </motion.div>
        </Modal>
    );
};

export default ModalVerificarCte;